import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Simulator from "@/pages/Simulator";
import Result from "@/pages/Result";
import LeadForm from "@/pages/LeadForm";
import Admin from "@/pages/Admin";
import { CookieBanner } from "@/components/CookieBanner";

function App() {
  return (
    <div className="min-h-screen w-full bg-[#EFE9DF] flex justify-center">
      <div className="max-w-[480px] w-full bg-[#FAF6F0] shadow-[0_0_40px_rgba(42,36,33,0.06)] relative overflow-x-hidden min-h-screen flex flex-col">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/simulateur/:slug" element={<Simulator />} />
            <Route path="/resultat" element={<Result />} />
            <Route path="/contact" element={<LeadForm />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <CookieBanner />
        <Toaster position="top-center" richColors />
      </div>
    </div>
  );
}

export default App;
